import { LinkType } from "../types/baseTypes";

const isLinkTypeObject = (
  link: LinkType,
): link is Exclude<LinkType, null | ""> =>
  link !== null && link !== "" && typeof link === "object";

export const passACFLink = <LinkKey extends string>(
  obj: Record<LinkKey, LinkType>,
  link_key: LinkKey,
) => {
  const link = obj[link_key];

  if (link && isLinkTypeObject(link)) {
    return {
      href: link.url,
      target: link.target,
      "aria-label": link.aria_label || link.title,
    };
  }

  return { href: "", title: "", target: "", "aria-label": "" };
};
